import { render, staticRenderFns } from "./TransferenciaDevolucaoEmprestimo.vue?vue&type=template&id=8f2ef850&"
import script from "./TransferenciaDevolucaoEmprestimo.vue?vue&type=script&lang=js&"
export * from "./TransferenciaDevolucaoEmprestimo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports